import http from 'hub-http/clients/apiClient';
import { safeGetCrmProperties } from 'personalization-lib/utils/assetData/crm';
const BASE_URL = '/crm-search/search';
export const fetchCrmObjectsByType = ({
  objectTypeId,
  filters,
  properties = [],
  search,
  offset,
  limit
}) => http.post(BASE_URL, {
  data: {
    objectTypeId,
    offset: offset !== null && offset !== void 0 ? offset : 0,
    count: limit !== null && limit !== void 0 ? limit : 10,
    query: search,
    filterGroups: [{
      filters
    }],
    requestOptions: {
      properties
    },
    sorts: [{
      property: 'hs_updated_at',
      order: 'DESC'
    }]
  }
});
export function createCrmObjectFetcher(params, resultsMapper) {
  return async paginationParams => {
    const properties = Object.values(params.propertiesMap);
    const response = await fetchCrmObjectsByType(Object.assign({
      objectTypeId: params.objectTypeId,
      properties,
      filters: params.filters
    }, paginationParams));
    const {
      total,
      offset,
      results
    } = response;
    const resultsWithExtractedProperties = results.map(res => safeGetCrmProperties(res, params.propertiesMap));
    return {
      total,
      offset,
      results: resultsMapper ? resultsMapper(resultsWithExtractedProperties) : resultsWithExtractedProperties
    };
  };
}